export const productInformationAttributes = {
    skinType: {
        visible: true,
        join: true
    },
    skinConcern: {
        visible: true,
        join: true
    },
    mkpConcern: {
        visible: true,
        join: true
    },
    hairType: {
        visible: true,
        join: false
    },
    hairTexture: {
        visible: true,
        join: true
    },
    hairConcern: {
        visible: true,
        join: true
    },
    hairBenefits: {
        visible: true,
        join: true
    },
    wellnessConcern: {
        visible: true,
        join: true
    },
    fragranceFamily: {
        visible: true,
        join: false
    },
    fragrancePersonality: {
        visible: true,
        join: false
    },
    perfumer: {
        visible: true,
        join: false
    },
    topNote: {
        visible: true,
        join: true
    },
    middleNote: {
        visible: true,
        join: true
    },
    baseNote: {
        visible: true,
        join: true
    },
    highlights: {
        visible: true,
        join: false
    },
    keyIngredients: {
        visible: false,
        join: false
    },
    without: {
        visible: true,
        join: false
    },
    howToUse: {
        visible: false,
        join: false
    },
    fullIngredientList: {
        visible: false,
        join: false
    },
    disclaimer: {
        visible: true,
        join: false
    }
}
